const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站支持 720P 至 4K 超清分辨率，自适应码率确保流畅观影。无论大屏小屏，每一帧都清晰细腻。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '汇聚 2000+ 部影视资源，覆盖国产剧、韩剧、古装、悬疑等全品类，每日持续更新扩充片库。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '热播剧集播出后 2 小时内同步上线，字幕组第一时间完成翻译，让你追剧永不错过。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">品质保障</h2>
          <p className="text-sm text-foreground-500">用心做好每一个细节，让你追剧无忧</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="text-center bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100">
                <i className={`${feat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}